import { DEBUG } from '@src/DEBUG'; 
DEBUG.open ( '/app/main.component.ts' );
import {combineLatest, empty as observableEmpty, fromEvent as observableFromEvent, Observable, of as observableOf, of} from 'rxjs';
import {concatMap, debounceTime, filter, flatMap, map, mergeMap, take} from 'rxjs/operators';
import {AfterContentChecked, OnInit, OnDestroy, ChangeDetectorRef, Component, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog, MatSidenav, MatSnackBar} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';
import {AppService} from '../commons/app.service';
import {AppRoutes} from '../commons/global';
import {Account, Dataset, Folder, FourDService, Project, TransformGroup} from '4d-mapper';
import {MainService} from './main.service';
import {FormControl} from '@angular/forms';
import {AppBaseComponent } from '../commons/AppBaseComponent';
import {MapService} from '../commons/map.service';
import {forkJoin} from 'rxjs/index';
import {FileStub} from './explorer/explorer.component';
import {Constants} from '../commons/Constants';
import {UploadGlobalComponent} from '../commons/dialogs/upload-global/upload-global.component';
import {UploadToProjectComponent} from '../commons/dialogs/upload-to-project/upload-to-project.component';
import {Subscription} from 'rxjs/Subscription';
import {SetupDialog} from '../commons/dialogs/setup-dialog';
import { AclService } from '../commons/acl/acl.service';
import { PluginManagerService } from '../service/plugin-manager.service';
import { StreamDataService } from '../v2/commons/stream-data.service';
import { FileDataService } from '../v2/commons/file-data.service';
import { SharableComponent } from './sharable/sharable.component';
import { FdmPlugin } from '../commons/plugins/plugins';
import { MeasurementHelperService } from '../service/measurement-helper.service';
import { DomSanitizer } from '@angular/platform-browser';
import { LoadingSpinner } from '../commons/ui/loading-spinner';
import { XsApplicationEventsService } from '../xs/services/events/application-events.service';
import { UiManagerService } from '../xs/services/ui/ui-manager.service';
import { SceneControllerService } from '../service/controllers/scene-controller.service';
import { SnotifyService } from 'ng-snotify';
import { TicketRequest } from '../commons/models';
import { CesiumMapService } from '../service/map-viewer.service';
import { XsAwait } from '../xs/controllers/await.class';
import { XsIncomingDataService } from '../xs/services/data/incoming-data.service';


const _ = require('underscore')
const Cesium = (<any>window).Cesium;

// declare var fdm: any;

//var when = require('cesium/Source/ThirdParty/when');
// var lodash = require('lodash');

@Component({
  selector: 'main-comp',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MainComponent extends AppBaseComponent implements OnInit, OnDestroy, AfterContentChecked {

  debug:boolean = Constants.debug_off;
  errorNotiCounter = 0

  @ViewChild('sidenav', {static: false}) sidenav: MatSidenav;
  public navOpened: boolean
  public navMode: string
  public error: any;

  mini: boolean = true;
  reJig: boolean

  loading = true
  // $ = fdm;
  canAdd: boolean;

  noAccount: boolean
  mainLink: string = '/' + AppRoutes.MAIN;

  ADMIN_USERS = this.mainLink + '/' + AppRoutes.ADMIN_USERS;
  searchCont = new FormControl();
  private filesObs: Observable<FileStub>[];
  private subs: Subscription[] = [];

  // show advanced settings?
  showAdvanced:boolean = false;

  // show more position info?
  showPositionAdvanced:boolean = false;
  
  // show/hide the quick config
  showConfig:boolean = false;

  // is there a new Team added lately?
  isNewTeams:boolean = false;

  uploadButtonDragHover:boolean = false;

  tasks:any

  teamStats:any = null;

  isJapan:boolean = false;


  contactUsShow:boolean = false;
  contactUsState:string = 'ready';
  contactUsMessage:string = '';
  contactUsRequest:TicketRequest = null;
  

  constructor(public fourD: FourDService,
              public service: AppService,
              public router: Router,
              public snackBar: MatSnackBar,
              public dialog: MatDialog,
              public incomingData: XsIncomingDataService,
              public translate: TranslateService,
              private cdref: ChangeDetectorRef,
              public mapService: MapService,
              public cesiumMap: CesiumMapService,
              public mainService: MainService,
              public permissions: AclService,
              private activatedRoute: ActivatedRoute, 
              applicationEvents:XsApplicationEventsService,
              private v2Stream:StreamDataService,
              public v2FileService:FileDataService,
              public pluginManager: PluginManagerService,
              public measureHelper: MeasurementHelperService,
              public uiManager: UiManagerService,
              public sanitizer:DomSanitizer,
              public sceneController: SceneControllerService,
              private snotify: SnotifyService ) {

    super(service, router, snackBar, dialog, applicationEvents);

    DEBUG.log ( '/app/main.component.ts' );

    this.tasks = v2FileService.processingItems
    this.openEdgeWarningDialog();
    // Check if mobile screen and adjust sidenav
    this.navOpened = !this.isMobile()
    this.navMode = this.isMobile() ? 'over' : 'side'

    this.fourD.onSocketCommand('*').subscribe(a => {
      if ( this.debug ) { console.log('Socket', a); }
    });
    this.fourD.onSocketCommand('ping').subscribe(a => {
      if ( this.debug ) { this.fourD.sendSocket('pong'); }
    });
    this.fourD.onSocketCommand('credit_change').subscribe(a => {
      // console.log('credit', a)
      var account = this.fourD.teams.find(aa => aa.id == a.id)
      account.adhocCredit = a.adhocCredit
      account.autoCredit = a.autoCredit
    });
    // Subscribe to window resize event to change the nav mode
    observableFromEvent(window, 'resize').subscribe(event => this.navMode = this.isMobile() ? 'over' : 'side');

    /* disabled, possibly remove
    // access control changes
    this.permissions.updatedAccess$.subscribe(tmp => {
      if ( this.debug ) { console.log ( 'main subscribed event access control' );}
      this.service.roleUpdate();
    });
    */


    // main service onReady; it all starts here: subscribing to service.onReady pulls down account and profile
    service.onReady().pipe(flatMap(_ =>
      v2FileService.init()
    )).subscribe(s => {

      if ( this.debug ) { console.log ( 'main.comp Service onReady', s); }

        // details about the account
        var accountMeta = this.service.objectMetas.find(o => o.uid == 'Account');
        if ( this.debug ) { console.log ( 'Account meta', accountMeta);}

        // crude canAdd setting
        this.canAdd = !!accountMeta && !!accountMeta.acl.find(p => p == 'api_create');

        if (!fourD.teams.length) {
          this.noAccount = true;
          this.loading = false;
          return
        }

        // active user
        var toLoad = fourD.teams[0].uid;
        if (this.fourD.activeUser && this.fourD.activeUser['lastAccount'] && this.fourD.teams.find(t => t.uid == this.fourD.activeUser['lastAccount'])) {
          toLoad = this.fourD.activeUser['lastAccount'];
        }

        // teams


        this.v2FileService.initTeam(this.fourD.teams.find(t => t.uid == toLoad))
          .subscribe(succ => {
            this.loading = false;
            let team = this.fourD.activeTeam;
            if ( team ) {
              let hostname:string = team['hostname'] ? team['hostname'] : 'other'; 
              this.isJapan = hostname.indexOf('link') !== -1 ? true : false;
              // console.log('!!! hostname',team, hostname, this.isJapan );
              if ( this.debug ) { console.log("app.service :: onReady() Vasat ready"); }
            }

            this.fourD.getQuotas().subscribe(s => { 
              this.teamStats = s;
            });

            this.checkForNewTeams();

            // init all permissions for the current user
            // this.service.setupPermissions();
            // this.service.onRoleChange();

            this.updatePluginManager();

            LoadingSpinner.end();

          },err => {
            this.openSnackBarError('SIGNIN.ERROR.ACC_LOAD')
            this.loading = false;
            LoadingSpinner.end();
          }
          );
        // Messages
        var start, error, completed
        this.translate.get(['TASK.START', 'TASK.ERROR', 'TASK.COMPLETE']).pipe(
          map(params => {
            start = params['TASK.START']
            error = params['TASK.ERROR']
            completed = params['TASK.COMPLETE']
          }),
          mergeMap(e => {
            return fourD.runningTasksObservable
          })
        ).subscribe(t => {
          if (t.task.name == 'THUMB' || t.task.name == "JPG_DZI") return
          if (t.event == 'add') {
            this.openSnackBarInfo(start, null, {task: t.task})
          }
          else if (t.finished == true && t.task.error) {
            this.openSnackBarError(error, null, {task: t.task})
          } else if (t.finished == true && t.error) {
            this.openSnackBarError(error, null, {task: t.task})
          }
          else if (t.finished) {
            this.openSnackBarSuccess(completed, null, {task: t.task})
          }
        })
      }, e => {
        this.loading = false;
        this.error = e
      }
    )

    // not sure?
    this.searchFilesFolder();

    // upload events
    this.subs.push(this.mainService.uploadFilesSub.subscribe(e => {
      this.uploadFiles(e);
    }));

    // upload from dropbox
    this.subs.push(this.mainService.openDropBoxSub.subscribe(e => {
      this.uploadDropbox(e);
    }));

    
    // drop / upload events
    this.subs.push(this.mainService.dropFilesSub.subscribe(e => {
      this.dropFile(e);
    }));

    // upload existing files
    this.subs.push(this.mainService.uploadExistingFiles.subscribe(_ => {
      if (!this.isCurrentRouteProject() && this.isCurrentRouteProjectList()) {
        this.openUploadProjectDialog().subscribe(data => {
          if (data) {
            this.router.navigate(['projects', 'map', data.project.id],
              {
                relativeTo: this.activatedRoute,
                queryParams: {
                  sceneId: data.scene.id,
                  addExistingData: true
                }
              });
          }
        })
      }
    }));


    this.mapService.onCesiumReady().subscribe( _ => {
      // check the location toggle, and show/hide the location entity
      setTimeout ( () => {

        this.toggleLocation();

        // deal with some user settings
        this.onUserSettings();

      }, 1000 );
    });
  }

  onReady() {

    // Check if we have setup param, meaning we are coming from the initial setup page
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['setup']) {
        let dialogRef = this.dialog.open(SetupDialog, {
          width: '850px',
          data: {},
          panelClass: 'setup-bg',
          disableClose: true
        });

        return dialogRef.afterClosed()
      }
    })

    // Listen to vasat errors. Specifically listening to invalid token errors so we can redirect user to the login page.
    combineLatest([this.service.V.onErrorEvent, this.translate.get(["SIGNIN.SESSION_EXPIRE", "SIGNIN.SESSION_EXPIRE_TITLE"])]).subscribe( ([error,text]) => {
      //console.log("ERROR occurred error ",error)
      // If token invalid redirect to login page
      // Special case error when "Bad User credentials" as it has same error code 403 as other errors. This needs to be changed in Vasat. for now we just work around it
      if ((error.status == 405 || error.status == 406) && this.errorNotiCounter == 0) {
          // Keep counter to show error only once even if ther are multiple errors thrown
          this.errorNotiCounter = this.errorNotiCounter + 1
          this.service.V.invalidateSession()
          // Clear 4DM specific states
          this.fourD.clearStates()
          
          this.snotify.warning(text["SIGNIN.SESSION_EXPIRE"], text["SIGNIN.SESSION_EXPIRE_TITLE"], {timeout:4000}).on( "destroyed", (toast) => {
              this.errorNotiCounter = 0
          } )
          this.router.navigate(['auth'])             
      }
    })

  }

  onError(e) {
    if (e.status == 406 || e.status == 405) {
      this.fourD.clearStates()
      this.router.navigate(['/auth'])
    }
  }

  updatePluginManager() {
    setTimeout( () => {
      this.pluginManager.pluginCategories = [ FdmPlugin.category.generic ];
      if ( this.fourD && this.fourD.activeUser ) {
        if ( this.fourD.activeUser['showPluginsAdvanced'] ) {
          this.pluginManager.pluginCategories.push(FdmPlugin.category.advanced);
        }
        if ( this.fourD.activeUser['showPluginsTechnical'] ) {
          this.pluginManager.pluginCategories.push(FdmPlugin.category.technical);
        }
        if ( this.fourD.activeUser['showPluginsBeta'] ) {
          this.pluginManager.pluginCategories.push(FdmPlugin.category.beta);
        }
        if ( this.fourD.activeUser['showPluginsExperimental'] ) {
          this.pluginManager.pluginCategories.push(FdmPlugin.category.experimental);
        }
        if ( this.fourD.activeUser['showPluginsDebug'] ) {
          this.pluginManager.pluginCategories.push(FdmPlugin.category.debug);
        }
        if ( this.fourD.activeUser['showPluginsDeprecated'] ) {
          this.pluginManager.pluginCategories.push(FdmPlugin.category.deprecated);
        }
      }
      this.pluginManager.clearCacheAllControllers();
    }, 50 );
  }

  openURL( url:string ) {
    window.open(url, '_blank');
  }

  // configure stuff when a user changes their settings
  onUserSettings() {

    XsAwait.until( 'mapService.viewer', this ).then ( _ => {

      let viewer = this.mapService.viewer;
  
      if ( this.fourD && this.fourD.activeUser && viewer['scene'] ) {

        let a = this.fourD.activeUser;

        // should we show FPS?
        viewer['scene'].debugShowFramesPerSecond = a['showFPS'];

        // if no setting for showing coordinates, default is true
        if ( !a.hasOwnProperty('showCoordinates') ) {
          this.fourD.activeUser['showCoordinates'] = true;
        }
        if ( !a.hasOwnProperty('showCameraCoordinates') ) {
          this.fourD.activeUser['showCameraCoordinates'] = false;
        }

        if ( !a.hasOwnProperty('showContextMenu') ) {
          this.fourD.activeUser['showContextMenu'] = false;
        }

        this.uiManager.sidebarHeightAdjust();

      }
    });
    
  }

  

  saveProfileDelayed() {
    setTimeout ( () => { 
      this.onUserSettings(); 
      this.uiManager.sidebarHeightAdjust();
      this.fourD.activeUser.saveObservable().subscribe( a => { 
    
        var l = this.fourD.V.localSession()
        l.user = a
        this.fourD.V.saveLocalSession(l)

      } );
    }, 400 );
  }

  toggleLocation() {
    setTimeout ( () => { 
      if ( this.mapService.locationShape && this.fourD && this.fourD.activeUser ) {
        this.mapService.locationShape.show = this.fourD.activeUser['showLocation'];
      }
    }, 400 );
  }

  toggleCesiumDebugger() {
    //Add Cesium Inspector
    this.mapService.viewer.extend(Cesium.viewerCesiumInspectorMixin);
  }

  flyToLocation() {
    this.mapService.viewer.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(
        this.mapService.geolocation.longitude,
        this.mapService.geolocation.latitude,
        this.mapService.geolocation.height ? this.mapService.geolocation.height : ( this.mapService.geolocation.sampledHeight ? this.mapService.geolocation.sampledHeight : this.mapService.geolocation.cameraHeight )
      )
    });
  }

  augmentUserPermissions() {
    // the ACL permissions service is stashed away in the map.service, as it's included in most (if not all) other components
    // todo
  }

  togMini() {
    this.mini = !this.mini
    setTimeout(() => this.reJig = true, 200)
    setTimeout(() => this.reJig = false, 400)
  }

  menuClicked(option: string) {
    if (option == 'explorer') {
      this.navigateToRoute(this.routes.MAIN_EXPLORER)
    } else if (option == 'inspector') {
      this.navigateToRoute(this.routes.MAIN_INSPECTOR)
    } else if (option == 'settings') {
      this.navigateToRoute(this.routes.MAIN_SETTINGS)
    }
    // Close the menu drawer
    if (this.isMobile()) this.sidenav.toggle()
  }

  setActiveAccount(account: Account) {
    this.v2FileService.initTeam(account).subscribe(succ => {
        if (succ) {
          this.fourD.activeUser['lastAccount'] = account.uid
          this.fourD.activeUser.saveObservable().subscribe();
          this.navigateToRoute(this.routes.MAIN)
        }
      })
  }

  logout() {

    let me = this;

    this.translate.get(['GENERIC.OK', 'GENERIC.CANCEL', 'NAV.LOGOUT_MESSAGE', 'LOGOUT_ERROR']).pipe(
      
      mergeMap(trans => {
        this.error = trans['NAV.LOGOUT_ERROR']
        return this.openDialog(trans['NAV.LOGOUT_MESSAGE'], null, trans['GENERIC.OK'], trans['GENERIC.CANCEL'])
      }), 
      
      mergeMap(result => {

        if (result) {
          this.loading = true
          // Go to root page on logout
          me.router.navigateByUrl(AppRoutes.AUTH);
          
          return this.service.V.logoutObservable()
        } else {
          return observableEmpty()
        }

      }),).subscribe(
      succ => {
        this.loading = false
        this.fourD.clearStates();
        
      },
      err => {
        this.loading = false
        this.openSnackBarError(this.error)
      }
    )

  }

  reconnect() {
    this.fourD.initSocket(this.fourD.V.localSession())
  }

  addAccount() {
    var inp = {value: ''}
    this.openDialog('SETTINGS.NEW_ACCOUNT', 'SETTINGS.NEW_DESC', null, null, inp).subscribe(res => {
      if (res && res.length) {
        var accountId = res.replace(' ', '').toLowerCase()
        var a = new Account(this.service.V)
        a.name = res
        a.uid = accountId
        
        this.service.V.api('/api/Account/' + this.service.fourD.activeTeam.id + '.makeNew','post',a.toJSON()).subscribe(
          s => {
            this.openDialog('SETTINGS.ACCOUNT_MADE', 'SETTINGS.ACCOUNT_GOTO', 'GENERIC.YES').pipe(
              concatMap(s =>
                this.fourD.V.searchByObject(Account).queryObservable().pipe(map(r => {
                  this.fourD.domain = r.items.find(a => a.isDomain)
                  this.fourD.rootAccounts = r.items.filter(a => !a.parent && a.uid != 'sample')
                  this.fourD.sampleAccount = r.items.find(a => a.uid == 'sample' && a.active)
                  
                  this.fourD.teams = <any>r.items.filter(a => a.uid != 'sample')
                  return s
                })
                )
              )
            ).subscribe(s => {
              if (s) {
                this.fourD.setActiveTeam(accountId).subscribe(s =>
                  this.router.navigate(['app', 'admin', 'account'])
                )
              }
              else {

              }
            })
          },
          e => this.openSnackBarError('No permission to create account ' + e)
        )
      }
    })
  }


  ngAfterContentChecked(): void {
    this.cdref.detectChanges();
  }

  searchFilesFolder() {
    this.searchCont.valueChanges.pipe(debounceTime(1000)).subscribe(s => {
      this.mainService.searchFilesFolder.next(s);
    });
  }

  searchFilesFolderWithoutGlobal() {
    setTimeout(() => {
        this.mainService.searchFilesFolderWithoutGlobal.next();
      },
      1500);
  }

  toggleTeamFavourite() {
    if ( ! this.fourD.activeTeam.props.hasOwnProperty('isNew') ) {
      this.fourD.activeTeam.props['isNew'] = false;
    }
    this.fourD.activeTeam.props['isNew'] = ! this.fourD.activeTeam.props['isNew'];
    this.fourD.activeTeam.saveObservable().subscribe();
    this.checkForNewTeams();
  }


  checkForNewTeams() {

    // reset isNewTeams flag
    this.isNewTeams = false;

    // check if there are any new teams
    this.fourD.teams.forEach( t => {
      // console.log ( "!", t, )
      if ( t.props['isNew'] ) {
        this.isNewTeams = true;
      }
    });

  }

  setTeam(a: Account) {

    // console.log ( 'switching organization ...' );

    var u = this.fourD.V.localSession().user
    u['lastAccount'] = a.uid
    u.saveObservable().subscribe()

    this.loading = true

    this.v2FileService.initTeam(a).subscribe(succ => {
        this.router.navigate(['/app']);
        this.loading = false;
  
        if ( a.props['isNew'] ) {
          a.props['isNew'] = false;
        }
        a.saveObservable().subscribe();
        
        this.checkForNewTeams();
  
        // redo the permissions
        // this.service.setupPermissions();
        // this.service.onRoleChange();
      })

  
  }

  dragDropUploadButtonControl(e, entering) {
    this.uploadButtonDragHover = entering;
    e.preventDefault();
    e.stopPropagation();
  }

  helloDrop(e, entering) {
    this.mainService.isOver = entering
  }

  dragOver(e: DragEvent) {
    e.preventDefault()
    this.mainService.isOver = true
    return false
  }

  openSharableDialog() {
    let dialogRef = this.dialog.open(SharableComponent, {
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe();    
  }

  openUploadGlobalDialog() {
    let dialogRef = this.dialog.open(UploadGlobalComponent, {
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe();
  }

  openUploadProjectDialog(): Observable<any> {
    let dialogRef = this.dialog.open(UploadToProjectComponent, {
      panelClass: 'custom-dialog-container'
    });
    return dialogRef.afterClosed();
  }


  dropFile(e: DragEvent) {
    if (e.stopPropagation)
      e.stopPropagation()

    e.preventDefault()
    if (!this.mainService.selectedFolder && !this.isCurrentRouteProjectList()) {
      this.openDialog('FILE_LIST.DIALOG.SELECT_FOLDER').subscribe();
      this.mainService.isOver = false;
      return;
    }
    else if(e.dataTransfer.files.length > 20){
      this.openDialog('FILE_LIST.DIALOG.TOOMANY','FILE_LIST.DIALOG.TOOMANY_DESC').subscribe();
      return;
    }
    else if ((this.mainService.selectedFolder && this.mainService.selectedFolder.account != this.fourD.activeTeam) && !this.isCurrentRouteProjectList()) {
      this.openDialog('FILE_LIST.DIALOG.TEAM_WRONG').subscribe();
      this.mainService.isOver = false;
      return;
    }
    else {
      if (e.stopPropagation)
        e.stopPropagation()

      e.preventDefault()

      if (!this.isCurrentRouteProjectList() && this.mainService.dataType == 'Transform') {
        this.openSnackBarError('FILE_LIST.DIALOG.FILE_TYPE')
        return false
      }
      var filez = e.dataTransfer.files
      var l = filez.length
      var grp = _.groupBy(filez,
        (obj, i) =>
          '_' + Math.floor(i / 10)
      )
      this.selectFolderAndDeque(grp);
      this.mainService.isOver = false
      return false
    }
  }

  uploadFiles(e) {

    console.log('##### main :: uploadFiles()', e );
    
    if (e.stopPropagation)
      e.stopPropagation()

    e.preventDefault()
    if (!this.mainService.selectedFolder && !this.isCurrentRouteProjectList()) {
      this.openDialog('FILE_LIST.DIALOG.SELECT_FOLDER').subscribe();
      return false;
    } 
    else if(e.srcElement.files.length > 20){
      this.openDialog('FILE_LIST.DIALOG.TOOMANY','FILE_LIST.DIALOG.TOOMANY_DESC').subscribe();
      return false;
    } else {
      if (!this.isCurrentRouteProjectList() && this.mainService.dataType == 'Transform') {
        this.openSnackBarError('FILE_LIST.DIALOG.FILE_TYPE')
        return false
      }
      var filez = e.srcElement.files
      var l = filez.length
      var grp = _.groupBy(filez,
        (obj, i) =>
          '_' + Math.floor(i / 10)
      )
      this.selectFolderAndDeque(grp);
      return false
    }

  }

  deQueue(grp, folder, scene?: TransformGroup, project?: Project) {
    var a = Object.keys(grp)
    if (a.length) {
      var key = a[0]
      var items = grp[key]
      this._sendBatch(items, folder, scene, project).subscribe(s => {
        delete grp[key];
        this.triggerDatasetUploading(scene, project);
        this.deQueue(grp, folder, scene, project);
      }, e => {

        if (e.status == 92021)
          this.openDialog('PLAN.QUOTA', 'PLAN.QUOTA_DESC_DISK')
        else
          this.openSnackBarError(e.message)
      })
    }
  }

  uploadDropbox(file:any){
    var folder = null

    if (this.isCurrentRouteProjectList()) {
      if (this.isCurrentRouteProject()) {
        folder = this.mapService.scene.folder
      
      } else {
        this.openSnackBarError('FILE_LIST.NAV.DROPBOX_PROJECT')
      }
    } else {
      folder = this.mainService.selectedFolder['root'] ? null : this.mainService.selectedFolder
 
    }


    if(folder)
      file['targetFolder'] = folder.id
    this.fourD.V.api('/api/Account/' + this.fourD.activeTeam.id + '/dropbox','post',file)
      .subscribe(s => this.openSnackBarInfo('FILE_LIST.NAV.DROPBOX_DOWNLOAD'),
      e => this.openSnackBarError(e.message))
  }

  private selectFolderAndDeque(grp) {
    let folder;
    if (this.isCurrentRouteProjectList()) {
      if (this.isCurrentRouteProject()) {
        this.dequeFromProject(folder, grp, this.mapService.currentProject, this.mapService.scene);
      } else {
        this.openUploadProjectDialog().subscribe(data => {
          if (data) {
            this.dequeFromProject(folder, grp, data.project, data.scene);
          }
        });
      }
    } else {
      folder = this.mainService.selectedFolder['root'] ? null : this.mainService.selectedFolder
      this.deQueue(grp, folder)
    }
  }

  private dequeFromProject(folder: Folder, grp, project: Project, scene: TransformGroup) {
    if (scene.folder) { // if scene have folder then add to scene folder
      this.deQueue(grp, scene.folder, scene, project);
    } 
    //else if (project.folder) { // if project has folder but scene dont then create scene folder and upload to scene folder
    //  this.createSceneFolderAndDeque(grp, scene, project);
    //} 
    else { // create project folder then create scene folder and upload to scene folder
      this.createSceneFolderAndDeque(grp, scene, project);
    }
  }

  private triggerDatasetUploading(scene?: TransformGroup, project?: Project) {
    if (this.isCurrentRouteProjectList()) {
      if (!this.isCurrentRouteProject()) {
        this.router.navigate(['projects', 'map', project.id],
          {
            relativeTo: this.activatedRoute,
            queryParams: {sceneId: scene.id}
          });

      }
      this.mapService.datasetUploadingOrTilling.next();
    }
  }

  _sendBatch(files: File[], folder: Folder, scene?: TransformGroup, project?: Project): Observable<FileStub[]> {

    this.filesObs = files.map(v => {
      var name = v.name;
      if (scene) {
        var blank = new Dataset(this.service.V).set({
          name: name,
          folder: folder,
          incomplete_offset: 0,
          incomplete_seq: 0,
          incomplete_total: length,
          incomplete: true,
          for_transform_group: scene.id,
          // for_project: project ? project.id : -1
        });
      } else {
        var blank = new Dataset(this.service.V).set({
          name: name,
          folder: folder,
          incomplete_offset: 0,
          incomplete_seq: 0,
          incomplete_total: length,
          incomplete: true
        });
      }

      return this.service.V.searchByObject(Dataset)
        .equals('folder', folder ? folder.id : null)
        .equals('name', name)
        .queryObservable().pipe(
          flatMap(s => {
            if (s.items.length > 0 && !s.items[0].incomplete) {
              return this.openDialogWithMeta({file: v.name}, 'FILE_LIST.OVERRIDE.TITLE', 'FILE_LIST.OVERRIDE.MSG', 'GENERIC.YES', 'GENERIC.NO').pipe(mergeMap(res => {
                if (res)
                  return observableOf({
                    dataset: s.items[0],
                    file: v,
                    valid: true
                  })

                else
                  return observableOf({valid: false})
              }))
            }
            else if (s.items.length > 0 && s.items[0].incomplete) {
              return observableOf({
                dataset: s.items[0],
                file: v,
                valid: true
              })
            }
            else {
              return blank.saveObservable().pipe(map(ds => {
                return {
                  dataset: ds,
                  file: v,
                  valid: true
                }
              }))
            }
          })
        )
    })

    return forkJoin(this.filesObs).pipe(map(res => {
      res.forEach(s => {
        if (s.valid) {
          if (scene && this.isCurrentRouteProjectList() && this.mapService.datasetForLayers.findIndex(dl => dl.id === s.dataset.id) === -1) {
            // this.incomingData.add(s.dataset); // refactoring the below line
            this.mapService.datasetForLayers.push(s.dataset);
          }


          try {
            // add the upload to the list of files (unless its an override of existing file)
            if (this.filesObs.length < 10 && !this.isCurrentRouteProjectList() && this.mainService.fileListComponent) {
              // inject is not working from angular 8
              // this.mainService.fileListComponent.dataSource.injectVals([s.dataset])
              this.mainService.fileListComponent.refresh();
            }
          } catch (e) {
            console.error(e);
          }

          this.processObjFile(s.dataset, s.file);
          this.fourD.uploadFile(s.dataset, s.file, 'data', 19000000).error = (e) => {
            if (e.status == 92021)
              this.openDialog('PLAN.QUOTA', 'PLAN.QUOTA_DESC_DISK')
            else
              this.openSnackBarError(e.message)
          }
        }
      })

      return res
    }))

  }

  private isCurrentRouteProjectList() {
    return this.router.url.indexOf('app/projects') !== -1;
  }

  public isCurrentRouteProject() {
    return this.router.url.indexOf('app/projects/map') !== -1 && this.mapService.currentProject;
  }

  private processObjFile(dataset: Dataset, file: File) {
    if (!file || !file.name.endsWith('.obj'))
      return;
    var blob = file.slice(0, 1024);
    var reader = new FileReader();
    reader.readAsText(blob);

    reader.onload = (data) => {
      let csvData = reader.result as string;
      var a = csvData.split('\n')
      if (a.length > 3 && a[a.length - 2]) {
        // read mtlfilename from header and save it to the dataset
        for(let i=0; i < a.length; i++){
          if(a[i].indexOf('mtllib') !== -1){
          let mtlFileArray = a[i].split(' ');
          mtlFileArray.splice(0, 1);
          let mtlFileName = mtlFileArray.join(' ');
            dataset['mtlFileName'] = mtlFileName.trim();
            break;
          }
        }
        // read the x,y,z from the header and save it in the dataset
        a = a[a.length - 2].split(' ')
        if (a.length >= 4) {
          dataset['objFileXYZ'] = {
            x: a[1],
            y: a[2],
            z: a[3]
          };
          dataset.saveObservable().subscribe();
        }
      }
    }

    reader.onerror = () => {
      this.snackBar.open('GENERIC.READ_ERROR', 'GENERIC.ERROR', {duration: Constants.SNACKBAR_DURATION});
    };
  }

  private createProjectFolderAndDeque(grp: any, scene: TransformGroup, project: Project) {
  
    this.createSceneFolderAndDeque(grp, scene, project);
  
  }

  private createSceneFolderAndDeque(grp: any, scene: TransformGroup, project: Project) {
    // not creating folders anymore, jsut fetching ones server should have auto made.
    // (Note this wont help existing scenes, but could put a one of server code that generates folders for existing scenese if needed)
    scene.sceneFolder.subscribe(f => 
        this.deQueue(grp, f, scene, project)
    );
  }

  gotoContactUs() {

  }

  clickContactUs() {
    this.contactUsRequest = {
      subject:'',
      priority:'normal',
      category:'question',
      body:''
    };
    this.contactUsShow = true;
  }

  clickContactUsSend() {
    this.contactUsState = 'sending';
    const lf = '\n';
    this.contactUsRequest.body = `${lf}${this.contactUsMessage} ${lf}`;
    // send support tickets through ZenDesk
    this.service.sendSupportTicket(this.contactUsRequest).subscribe(
      res => {
        this.contactUsState = 'sent';
        //console.log('!! email OK', request, res );
      },e => {
        this.contactUsState = 'error';
        //console.log('!! email ERROR', request, e );
      }
    )
  }

  clickContactUsDone() {
    this.contactUsShow = false;
    this.contactUsState = 'ready';
  }

  autoFill ( name:string ) {
    if ( this.fourD ) {
      switch ( name ) {

        case 'NAME':
          if ( this.fourD.activeUser ) {
            return this.fourD.activeUser.name;
          }
          break;

        case 'EMAIL':
          if ( this.fourD.activeUser ) {
            return this.fourD.activeUser.email;
          }
          break;

        case 'USER_ID':
          if ( this.fourD.activeUser ) {
            return this.fourD.activeUser.id;
          }
          break;

        case 'ACCOUNT_ID':
          if ( this.fourD.activeTeam ) {
            return this.fourD.activeTeam.id;
          }
          break;
      }
    }
    return '';
  }

  showQuickGuides() {

    // Use the router URL to figure what screen we are on, so we open the correct quick guides
    var screen = ""
    if (this.router.url.includes("/app/projects/map")) {
      // Map screen
      screen = "map"
      // Dasboard screen
    } else if (this.router.url.includes("/app/projects")) {
      screen = "dashboard"
      // Data explorer screen
    } else if (this.router.url.includes("/app/explorer")) {
      screen = "explorer"
    // User management screen
  }    else if (this.router.url.includes("/app/admin/users")) {
        screen = "users"
  // Account screen
  }    else if (this.router.url.includes("/app/admin/account")) {
    screen = "account"
      // Plans and credit screen
} else if (this.router.url.includes("/app/admin/plan")) {
    screen = "plan"
}
    this.uiManager.toggleQuickGuidePopup(screen, true)
  }
}
